// extracted by mini-css-extract-plugin
module.exports = {"section":"SettingsSection_section__2LMyy","content":"SettingsSection_content__2ESpC"};